const wooAccount = {
  init() {
    this.addresses();
    this.register();
    this.events();
  },

  events() {
    $("#change-password").on("click", function () {
      $(".edit-profile__passwords").toggleClass("hidden");
    });
  },

  addresses() {
    const formEl = $(".edit-address");

    formEl.find('input[name="person"]').on("change", function () {
      const input = $(this);
      if (input.attr("id") == "legal-person") {
        formEl.find(".legal").slideDown();
      } else {
        formEl.find(".legal").slideUp();
      }
    });
  },

  register() {
    const registerFormEl = $(".register");

    registerFormEl
      .find('input[name="reg_person-type"]')
      .on("change", function () {
        const input = $(this);
        if (input.attr("id") == "reg_legal-person") {
          registerFormEl.find(".legal").show();
        } else {
          registerFormEl.find(".legal").hide();
        }
      });
  },
};

export default wooAccount;
